module.exports = __webpack_public_path__ + "img/log.83fd65b8.svg";